import { render, staticRenderFns } from "./CreateShiftTypeComponent.vue?vue&type=template&id=0e7608e2&scoped=true"
import script from "./CreateShiftTypeComponent.vue?vue&type=script&lang=js"
export * from "./CreateShiftTypeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7608e2",
  null
  
)

export default component.exports